(function(SCS) {
	'use strict';

	var search = SCS.search || {};
	var extend = search.util.extend;

	function saveInputConfig(blacklist) {
		blacklist = blacklist || {};
		// Saves the config that was input initially (rather than what all the later plugins modified)
		// so that when re-sending or modifying old queries we don’t have to set all the auto-generated config attributes
		// (we can use this to de-duplicate running queries from a responder instead of stopping and re-starting them)
		return function inputConfigSaver(config, callback) {
			config.inputConfig = extend({}, config);
			for(var k in blacklist) {
				// jshint forin: false
				delete config.inputConfig[k];
			}
			callback();
		};
	}

	function setBaseURL(baseURL, suffix, backendType) {
		backendType = backendType || 'gsa';
		// Sets the given baseURL as the URL to use for a request.
		// Should be added very early (low weight) in the pre-filter chain.
		return function baseURLSetter(config, callback) {
			config.url = baseURL + (config.url || suffix || '');
			config.endpointURL = config.url;
			config.baseURL = baseURL;
			config.backendType = backendType;
			callback();
		};
	}

	var DEFAULT_CONFIG = {requester: 'user', origin: null};
	function addDefaultConfig(defaultConfig, customConfig) {
		defaultConfig = extend({}, defaultConfig || DEFAULT_CONFIG, customConfig || {});
		// If a param exists in defaultConfig but not in config, it is taken from there.
		// Should be added just before transposeParams.
		return function defaultConfigAdder(config, callback) {
			config = extend({}, defaultConfig, config);
			callback(config);
		};
	}
	addDefaultConfig.DEFAULT_QUERY = extend({}, DEFAULT_CONFIG, {
		page: 0,
		offset: 0
	});
	
	// FIXME: Move to orchestration or gsa-handling
	var GSA_BASE = {
		client: '', // e.g. sc_v2_f_res_de
		query: '',
		site: '',
		getfields: '*'
	};
	var GSA_QUERY = extend({}, GSA_BASE, {
		proxystylesheet: 'sc_v2b_p_json_default',
		language: 'de' // e.g. lang_de
	});
	addDefaultConfig.GSA_SEARCH_CONFIG = extend({}, addDefaultConfig.DEFAULT_QUERY, GSA_QUERY, {
		resultLimit: 10,
		keyMatchLimit: 0,
		gsaFilter: 'both'
	});
	addDefaultConfig.GSA_SUGGEST_CONFIG = extend({}, DEFAULT_CONFIG, GSA_BASE, {
		format: 'rich',
		suggestionLimit: 5,
		gsaFilter: 'duplicateSnippet'
	});
	addDefaultConfig.GSA_CLUSTER_CONFIG = extend({}, DEFAULT_CONFIG, GSA_QUERY, {
		gsaFilter: 'duplicateSnippet'
	});


	function transposeParams(map) {
		map = map || {};
		// Transposes config.params according to the given map (from => to)
		// Used so we can have unified names of params that work for all backends (e.g. “query”)
		// And then have them transposed into backend-specific names (e.g. “q” for GSA)
		// Should be added before flattenParams but after all the param mingling is done (including addDefaultConfig).
		return function paramsTransposer(config, callback) {
			config.params = config.params || {};
			config.untransposedParams = extend({}, config.params);
			for(var name in map) {
				// jshint forin: false
				if(name in config) {
					config.untransposedParams[name] = config[name];
					if(map[name].constructor === Function) {
						map[name](config[name], config.params);
					} else {
						var newName = map[name] === true ? name : map[name];
						config.params[newName] = config[name];
					}
				}
			}
			callback();
		};
	}
	
	// FIXME: Move to orchestration
	transposeParams.GSA_MAP = {
		query: 'q',
		language: function transposeLanguage(language, params) {
			params.lr = 'lang_' + language;
		},
		client: true,
		site: true, // e.g. sc_v2_c_res_de_live
		getfields: true,
		gsaFilter: function transposeGsaFilter(gsaFilter, params) {
			if(gsaFilter === 'duplicateSnippet') {
				gsaFilter = 'p';
			} else if(gsaFilter === 'duplicateDirectory') {
				gsaFilter = 's';
			} else if(gsaFilter === 'none') {
				gsaFilter = '0';
			} else if(gsaFilter === 'both' || !gsaFilter) {
				// This is the default, don’t add the param
				// gsaFilter = '1'
				return;
			}
			params.filter = gsaFilter;
		},
		proxystylesheet: true,
		requiredfields: true, // gsaentity_GSA_Area:2_business
		format: true, // rich
		resultLimit: 'num',
		keyMatchLimit: 'numgm',
		suggestionLimit: 'max',
		offset: 'start'
	};
	transposeParams.GSA_TITLE_MAP = extend({}, {
		query: 't'
	}, transposeParams.GSA_MAP);

	function flattenParams(paramizeFunction) {
		paramizeFunction = paramizeFunction || search.util.param;
		// Generates the final URL by addind config.params as GET params to the URL.
		// Should be added very late (high weight) in the pre-filter chain of a SearchProcessor.
		return function paramsFlattener(config, callback) {
			config.params = config.params || {};
			config.url = typeof(config.url) === 'string' ? config.url : '/';
			config.baseURL = config.baseURL || config.url;
			config.rootURL = config.url;
			config.urlParams = paramizeFunction(config.params);
			var separator = config.url.indexOf('?') > -1 ? '&' : '?';
			config.url = config.url + separator + config.urlParams;
			callback();
		};
	}

	function prependRequestMethod(defaultMethod) {
		defaultMethod = defaultMethod || 'GET';
		// Prepend the request method to the URL for the ajax backend (but to still have nice cache keys)
		return function requestMethodPrepender(config, callback) {
			config.method = String(config.method || defaultMethod).toUpperCase();
			config.requestUrl = config.url;
			config.url = '['+config.method+']'+config.requestUrl;
			callback();
		};
	}

	function setUp(processor, inputConfigSaver, baseURLSetter, defaultConfigAdder, paramsTransposer, paramsFlattener, requestMethodPrepender) {
		processor.usePre(inputConfigSaver||saveInputConfig(), -2000000);
		processor.usePre(baseURLSetter, -1000000);
		if(defaultConfigAdder) {
			processor.usePre(defaultConfigAdder, 1000);
		}
		processor.usePre(paramsTransposer||transposeParams(), 1000000);
		processor.usePre(paramsFlattener||flattenParams(), 2000000);
		processor.usePre(requestMethodPrepender||prependRequestMethod(), 3000000);
	}

	var plugins = search.plugins = search.plugins || {};
	var url = plugins.url = plugins.url || {};

	url.saveInputConfig = saveInputConfig;
	url.setBaseURL = setBaseURL;
	url.addDefaultConfig = addDefaultConfig;
	url.transposeParams = transposeParams;
	url.flattenParams = flattenParams;
	url.prependRequestMethod = prependRequestMethod;
	url.setUp = setUp;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/url-handling.js
// module id = 49
// module chunks = 0